import type { Room,  SegType, Segment, KpiData } from './types';


export const ROOMS: Room[] = [
  { id: "CR-01", blk: "Block A", cs: "CWP/4421/2024",    jg: "Hon. Justice R. Mehra",   status: "flagged", vw: 142, dur: "01:42:18", bg: "#0f1520", gl: "rgba(180,30,30,.6)",  cam: "CAM-A1", bench: "Family",        flagType: "PII"     },
  { id: "CR-02", blk: "Block A", cs: "CS/881/2025",       jg: "Hon. Justice S. Kumar",   status: "live",    vw: 88,  dur: "00:42:05", bg: "#0b1624", gl: "rgba(26,80,160,.6)",  cam: "CAM-A2", bench: "Civil"                        },
  { id: "CR-03", blk: "Block B", cs: "Crl.A/1102/2024",  jg: "Hon. Justice P. Sharma",  status: "live",    vw: 214, dur: "00:12:44", bg: "#0b1a20", gl: "rgba(18,80,100,.6)",  cam: "CAM-B1", bench: "Criminal"                     },
  { id: "CR-04", blk: "Block B", cs: "WP/3320/2025",     jg: "Resumes 2:00 PM",          status: "paused",  vw: 0,   dur: "01:15:00", bg: "#111008", gl: "rgba(90,70,10,.5)",   cam: "CAM-B2", bench: "Constitutional"               },
  { id: "CR-05", blk: "Block C", cs: "MA/556/2025",      jg: "Hon. Justice D. Iyer",    status: "live",    vw: 67,  dur: "00:00:38", bg: "#0b1624", gl: "rgba(20,70,160,.6)",  cam: "CAM-C1", bench: "Misc"                         },
  { id: "CR-06", blk: "Block C", cs: "SA/1089/2024",     jg: "No stream · Sensitive",   status: "rec",     vw: 0,   dur: "01:27:22", bg: "#100b1e", gl: "rgba(60,20,120,.6)",  cam: "CAM-C2", bench: "Sensitive"                    },
  { id: "CR-07", blk: "Block D", cs: "RFA/774/2025",     jg: "Hon. Justice A. Nair",    status: "live",    vw: 39,  dur: "00:31:10", bg: "#091820", gl: "rgba(10,80,90,.6)",   cam: "CAM-D1", bench: "Appeal"                       },
  { id: "CR-08", blk: "Block D", cs: "Crl.Rev/220/2024", jg: "Hon. Justice B. Das",     status: "flagged", vw: 101, dur: "00:58:05", bg: "#1a0b0b", gl: "rgba(160,20,20,.5)",  cam: "CAM-D2", bench: "Criminal",     flagType: "Conduct" },
  { id: "CR-09", blk: "Block E", cs: "—",                jg: "—",                        status: "offline", vw: 0,   dur: "—",        bg: "#0c0c12", gl: "rgba(30,30,40,.6)",   cam: "CAM-E1", bench: "—",            offReason: "AV Maintenance", nextSession: "2:30 PM · Arb/112/2025" },
  { id: "CR-10", blk: "Block E", cs: "IA/3301/2025",     jg: "Hon. Justice M. Pillai",  status: "live",    vw: 55,  dur: "00:08:17", bg: "#0b1520", gl: "rgba(15,60,140,.5)",  cam: "CAM-E2", bench: "Civil"                        },
];



export const segColor: Record<SegType, string> = {
  l:  "bg-green-400",
  f:  "bg-red-400",
  r:  "bg-gray-300",
  rc: "bg-violet-400",
};

export const segText: Record<SegType, string> = {
  l:  "text-green-800",
  f:  "text-white",
  r:  "text-gray-600",
  rc: "text-violet-900",
};

export const TL_DATA: { rm: string; cs: string; segs: Segment[] }[] = [
  { rm: "CR-01", cs: "CWP/4421/2024",   segs: [{ t: "l", f: 2.8 }, { t: "f", f: 0.6, lb: "⚑", ti: "PII flag at 10:38 — address disclosed" }, { t: "l", f: 1.8 }, { t: "N" }] },
  { rm: "CR-02", cs: "CS/881/2025",     segs: [{ t: "l", f: 2 }, { t: "r", f: 0.5, lb: "brk" }, { t: "l", f: 3 }, { t: "N" }] },
  { rm: "CR-03", cs: "Crl.A/1102/2024", segs: [{ t: "r", f: 1.5, lb: "—" }, { t: "l", f: 4 }, { t: "N" }] },
  { rm: "CR-04", cs: "WP/3320/2025",    segs: [{ t: "l", f: 2.5 }, { t: "r", f: 1.5, lb: "lunch" }, { t: "N" }] },
  { rm: "CR-06", cs: "SA/1089/2024",    segs: [{ t: "rc", f: 3, lb: "▥ rec only" }, { t: "N" }] },
  { rm: "CR-07", cs: "RFA/774/2025",    segs: [{ t: "r", f: 1, lb: "—" }, { t: "l", f: 3 }, { t: "N" }] },
  { rm: "CR-10", cs: "IA/3301/2025",    segs: [{ t: "l", f: 1.5 }, { t: "N" }] },
];


export const STATUS_CONFIG: Record<
  import('./types').RoomStatus,
  { label: string; color: string; pillClass: string }
> = {
  live:    { label: "Live",     color: "#22C55E", pillClass: "pl" },
  paused:  { label: "Paused",   color: "#F59E0B", pillClass: "pp" },
  flagged: { label: "Flagged",  color: "#EF4444", pillClass: "pf" },
  rec:     { label: "Rec only", color: "#A78BFA", pillClass: "pr" },
  offline: { label: "Offline",  color: "#9CA3AF", pillClass: "po" },
};



export const KPI_CARDS = [
  {
    key:        "liveStreams"     as const,
    label:      "Live Streams",
    scrollTo:   "crSec",
    dotColor:   "#22C55E",
    valueColor: "#16A34A",
    pulse:      true,   
  },
  {
    key:        "archivalPending" as const,
    label:      "Archival Requests",
    scrollTo:   "archivalSec",
    dotColor:   "#F59E0B",
    valueColor: "#B45309",
    pulse:      false,
  },
  {
    key:        "flaggedCount"    as const,
    label:      "Flagged Content",
    scrollTo:   "flagPan",
    dotColor:   "#EF4444",
    valueColor: "#DC2626",
    pulse:      true,
  },
  {
    key:        "recordingToday" as const,
    label:      "Recordings Today",
    scrollTo:   "tlPan",
    dotColor:   "#6366F1",
    valueColor: "#4F46E5",
    pulse:      false,
  },
] satisfies Array<{
  key: keyof KpiData;
  label: string;
  scrollTo: string;
  dotColor: string;
  valueColor: string;
  pulse: boolean;
}>;


export const WS_STALE_THRESHOLD_MS = 60_000;


export function deriveKpiFromRooms(rooms: Room[]): KpiData {
  return {
    liveStreams:      rooms.filter(r => r.status === "live").length,
    totalCourtrooms:  rooms.length,
    archivalPending: 0,
    archivalTotal:    0,
    flaggedCount:     rooms.filter(r => r.status === "flagged").length,
    flagPIICount:     rooms.filter(r => r.flagType === "PII").length,
    flagConductCount: rooms.filter(r => r.flagType === "Conduct").length,
    flagOtherCount:   0,
    recordingToday:   rooms.filter(r => ["live","rec","flagged"].includes(r.status)).length,
    storageTodayGB:   "0.00",
  };
}